// extracted by mini-css-extract-plugin
export default {"link":"HeadPage_link__KyI6u","lastLink":"HeadPage_lastLink__R9-cg"};